import '../App.css';
import { gql, useApolloClient } from "@apollo/client";
import { useEffect, useState } from 'react';

const GET_DATA_PAGINATED = gql`
  query GetMicronarrativas($after: String, $first: Int = 100, $order: OrderEnum = ASC) {
    micronarrativas(first: $first, after: $after, where: { orderby: { field: DATE, order: $order } }) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node {
          id
          title
          micronarrativasMeta {
            hotspot
            data
            latitude
            longitude
            tags_micro {
              edges {
                node {
                  id
                  name
                }
              }
            }
            narrativa
            imagem {
              node {
                sourceUrl(size: LARGE)
              }
            }
            autor
          }
        }
      }
    }
  }
`;

function useAllData() {
  const client = useApolloClient();
  const [state, setState] = useState({ loading: true, error: null, data: [] });

  useEffect(() => {
    let cancelled = false;

    async function fetchAll() {
      let after = null;
      let allEdges = [];

      try {
        do {
          // This call now "sees" GET_DATA_PAGINATED defined above
          const { data } = await client.query({
            query: GET_DATA_PAGINATED,
            variables: { after, first: 100 },
            fetchPolicy: 'network-only',
          });

          const conn = data?.micronarrativas;
          if (!conn) break;

          allEdges = [...allEdges, ...(conn.edges || [])];
          after = conn.pageInfo?.endCursor || null;

          if (!conn.pageInfo?.hasNextPage) break;
        } while (true);

        if (cancelled) return;

        const filtered = allEdges.map(({ node }) => ({
          id: node.id,
          narrativa: node.micronarrativasMeta?.narrativa ?? "",
          data: node.micronarrativasMeta?.data ?? "",
          tags: node.micronarrativasMeta.tags_micro.edges,
          imagem: node.micronarrativasMeta?.imagem?.node?.sourceUrl ?? "",
        }));

        setState({ loading: false, error: null, data: filtered });
      } catch (error) {
        if (cancelled) return;
        setState({ loading: false, error, data: [] });
      }
    }

    fetchAll();
    return () => { cancelled = true; };
  }, [client]);

  return state;
}

export default function AllDataPage() {
    const [mousePosition, setMousePosition] = useState({x: 0, y: 0});
    const [isHovered, setIsHovered] = useState(false);
    const [indexMicro, setIndexMicro] = useState(null);

    useEffect(() => {
      const handleMouseMove = (e) => {
        setMousePosition({x: e.clientX, y: e.clientY});
      }

      window.addEventListener("mousemove", handleMouseMove);

      return () => {
        window.removeEventListener("mousemove", handleMouseMove)
      }
    }, []); 
    
    const { loading, error, data: micronarrativas } = useAllData();

    if (loading && micronarrativas.length === 0) return <p>Loading all entries...</p>;
    if (error) return <p>Error: {error.message}</p>;
    
    const handleHover = (index) => () => {
        setIndexMicro(index);
        setIsHovered(true);
    }

    const handleHoverOver = () => {
        setIsHovered(false);
        setIndexMicro(null);
    }

    const handleTagClick = (tag) => {
      window.open(`/tags/${tag}`, '_blank');
    };

    return (
        <div className='images-gallery'>
          {micronarrativas.map((item, index) => (
            <div key={item.id} className='item-wrapper' onMouseEnter={handleHover(index)} onMouseLeave={handleHoverOver}>
              <div className='image-thumb' key={item.id}>
              {item.imagem && <img loading="lazy" src={item.imagem} />}
            </div>
              <div className='Tags'>
              {item.tags.map(({ node, id }) => (
                <span
                  key={id}
                  className='Tag'
                  onClick={() => handleTagClick(node.name)}
                  style={{ cursor: 'pointer' }}
                >
                {node.name}
                </span>
              ))}
            </div>
          </div>
          ))}
          {
            isHovered && <div className='hover-micro' style={{ top:`${mousePosition.y + 20 }px`, left:`${mousePosition.x + 20}px` }}>
              <span>{micronarrativas[indexMicro].narrativa}</span>
              <span>{new Date(micronarrativas[indexMicro].data).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</span>
            </div>
          }
        </div>
    );
}